import { render, staticRenderFns } from "./list_tabs.vue?vue&type=template&id=a43dcf18"
import script from "./list_tabs.vue?vue&type=script&lang=js"
export * from "./list_tabs.vue?vue&type=script&lang=js"
import style0 from "./list_tabs.vue?vue&type=style&index=0&id=a43dcf18&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports